import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Lookup({ selectedInstance }) {
  let navigate = useNavigate();

  const [data, setData] = useState([]);
  const [value, setValue] = useState("");

  const handleChange = (event) => {
    setValue(event.target.value);
    fetch(terms + event.target.value)
      .then((res) => res.json())
      .then((json) => setData(json.suggestions));
  };

  const handleKeypress = (e) => {
    const search = e.target.value;
    if (e.key === "Enter") {
      navigate(`/results/${search}?instance=${selectedInstance}`);
    }
  };

  const terms = `${selectedInstance}/api/v1/search/suggestions?q=`;

  return (
    <>
      <div className="container mx-auto flex flex-wrap mb-4 flex-col md:flex-row items-center mt-4">
        <div className="mx-auto justify-center relative text-gray-500">
          <div className="relative">
            <input
              type="text"
              className="md:w-screen container p-2 pl-8 rounded border border-gray-200 bg-gray-200 focus:bg-white focus:outline-none focus:ring-2 focus:ring-yellow-600 focus:border-transparent"
              value={value}
              onChange={handleChange}
              onKeyPress={handleKeypress}
              placeholder="Search Videos"
            />
            <svg
              className="w-4 h-4 absolute left-2.5 top-3.5"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap">
        {data
          .filter((item) => {
            const searchTerm = value.toLowerCase();
            const search = item.toLowerCase();

            return (
              searchTerm &&
              search.startsWith(searchTerm) &&
              search !== searchTerm
            );
          })
          .slice(0, 10)
          .map((item) => (
            <div className="xl:w-1/4 md:w-1/4 mx-auto m-2 p-2 w-1/2" key={item}>
              <div className="bg-gray-100 p-2 w-wrap rounded-lg cursor-pointer hover:text-gray-900  hover:bg-yellow-50">
                <Link
                  to={`/results/${item}?instance=${selectedInstance}`}
                  onClick={() => setValue(item)}
                >
                  <ul>
                    <li className="text-center">{item}</li>
                  </ul>
                </Link>
              </div>
            </div>
          ))}
      </div>
    </>
  );
}
